export function giftContentChange(item) {
  let content
  // giftType 赠品活动类型：41：常规赠品 42：会员加赠 43：整点加赠 44：仅赠券 45：权益赠品
  // gift_content##内容id(1:整点加赠;2:常规赠品;3:会员加赠)
  if (item.giftType == 41) {
    content = 2
  } else if (item.giftType == 42) {
    content = 3
  } else if (item.giftType == 43) {
    content = 1
  } else if (item.giftType == 45) {
    content = 4
  }
  return content
}
